module.exports = __webpack_public_path__ + "img/kaizer-chiefs.927803ae.png";